<div
  class="audio-annotation-component"
  [class.private]="privateCondition !== null"
  [class.fullscreen]="isFullscreen"
  [class.has-comment]="hasComment">
  @if (!isFullscreen || !isCompareMode) {
    <ng-container [ngTemplateOutlet]="topMediaInfoTemplate"></ng-container>
  }
  <div class="audio-element-component">
    <div class="waveform-container" id="waveform-container-{{ instanceId }}" #waveformContainer>
      <div id="temp"></div>
      <div class="wave-forme" id="waveform-{{ instanceId }}"></div>
      <div class="wave-form-pre" [ngClass]="{ active: waveFormsDisplay }" id="waveform2-{{ instanceId }}"></div>
      <div
        class="wave-form-post"
        [ngClass]="{ active: waveFormsDisplay }"
        id="waveform3-{{ instanceId }}"
        #postWaveform></div>
    </div>
    <!-- <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container> -->
  </div>
  <div
    [hidden]="!isAnnotationDisplayEnabled"
    [ngClass]="{
      disabled: !isAnnotationDisplayEnabled || annotatingMode === true,
      'justify-content-end': annotation.left > 50,
      active: activeAnnotation && activeAnnotation?.data && activeAnnotation?.data.id === annotation.id,
      inactive:
        activeAnnotation &&
        activeAnnotation.type === 'click' &&
        activeAnnotation?.data &&
        activeAnnotation?.data.id !== annotation.id,
    }"
    class="annotation-marker px-1 d-flex align-items-end"
    *ngFor="let annotation of annotationData; let i = index"
    [ngStyle]="{ left: `${annotation.left}%`, width: `${annotation.width}%`, 'z-index': 400 }"
    #marker>
  </div>
  <div class="player-container">
    <div
      *ngIf="playerReady"
      class="progress-bar"
      (mousemove)="onProgressBarMouseMove($event)"
      (mouseleave)="onProgressBarMouseLeave()">
      <input
        type="range"
        (input)="updateAudioTime($event.target.value)"
        (click)="inputClickChange()"
        [value]="currentTime"
        min="0"
        max="{{ audioDuration }}"
        step="{{ audioStep }}"
        class="w-100 current-time-input"
        id="progress-navigation-{{ instanceId }}"
        [style.--played-percent]="playedPercent"
        [ngClass]="{ 'invalid-user': checkInvalidUser() }" />
      <div
        class="progress-bar-tooltip"
        [hidden]="!progressTooltipVisible"
        [style.left.px]="progressTooltipX"
        [style.top.px]="progressTooltipY - 40"
        aria-hidden="true"
        >{{ progressTooltipText }}</div
      >
    </div>
    <div class="player-controls d-flex" #controlBar>
      <div class="d-flex control-bar-left">
        <viewer-play-button [playing]="playerState" (togglePlay)="audioPausePlay()"></viewer-play-button>
        <viewer-volume-button
          [muted]="volumeMute || volume === 0"
          [volume]="volume / 2"
          (toggleMute)="toggleMute()"
          (volumeChange)="updateVolume($event * 2)"></viewer-volume-button>
        @if (pluginReady) {
          <viewer-time-display
            [currentTime]="currentTime"
            [duration]="audioDuration"
            (displayFormatChange)="onTimeDisplayFormatChange($event)"></viewer-time-display>
        }
      </div>

      <div class="d-flex control-bar-right">
        <viewer-reject-button></viewer-reject-button>
        <viewer-approve-button></viewer-approve-button>
        <viewer-compare-button
          [projectId]="projectId || item?.projectId"
          [sectionId]="sectionId || item?.sectionId"
          [subsectionId]="subsectionId || item?.subSectionId"
          [optionId]="typeId || item?.optionId || item?.itemId"
          [versionNumber]="item?.versionNumber"
          [fileId]="item?.id"></viewer-compare-button>
        @if (!controlBarIsNarrow) {
          <mtm-file-download-control
            [file]="item"
            displayType="icon"
            #downloadButton
            [iconSize]="18"
            [lightIcon]="true"
            [iconColor]="'#b0b0b0'"
            [uniqueControlId]="`${item.projectId}-${item.sectionId}-${item.subSectionId}-${item.id}`">
          </mtm-file-download-control>
        }
        <viewer-info-button [file]="item"></viewer-info-button>
        <viewer-annotation-toggle-button [isActive]="isAnnotationDisplayEnabled" (clicked)="toggleAnnotationDisplay()">
        </viewer-annotation-toggle-button>
        <viewer-settings-button
          [mode]="'audio'"
          [item]="item"
          [instanceId]="instanceId"
          [playbackRate]="currentPlaybackRate"
          (playbackRateChange)="onSettingsChange($event)"></viewer-settings-button>
        @if (!controlBarIsNarrow) {
          <viewer-cinema-mode-button
            class="zoom-chevron"
            [isFullscreen]="isFullscreen"
            (exitFullscreenRequest)="onCinemaModeExitFullscreen()"></viewer-cinema-mode-button>
          <viewer-fullscreen-button
            [active]="isFullscreen"
            (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button>
        }
        @if (controlBarIsNarrow) {
          <div ngbDropdown class="control-bar-more-dropdown" container="body" placement="top">
            <button
              type="button"
              class="viewer-controller-icon-btn control-bar-more-toggle"
              ngbDropdownToggle
              aria-haspopup="true"
              [attr.aria-label]="'More' | translate">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <circle cx="8" cy="3" r="1.25" fill="currentColor" />
                <circle cx="8" cy="8" r="1.25" fill="currentColor" />
                <circle cx="8" cy="13" r="1.25" fill="currentColor" />
              </svg>
            </button>
            <div ngbDropdownMenu class="control-bar-more-menu">
              <div class="control-bar-more-menu-inner">
                <mtm-file-download-control
                  [file]="item"
                  displayType="icon"
                  #downloadButton
                  [iconSize]="18"
                  [lightIcon]="true"
                  [iconColor]="'#b0b0b0'"
                  [uniqueControlId]="`${item.projectId}-${item.sectionId}-${item.subSectionId}-${item.id}`">
                </mtm-file-download-control>
                <viewer-cinema-mode-button
                  class="zoom-chevron"
                  [isFullscreen]="isFullscreen"
                  (exitFullscreenRequest)="onCinemaModeExitFullscreen()"></viewer-cinema-mode-button>
                <viewer-fullscreen-button
                  [active]="isFullscreen"
                  (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if (preWaveFormReady && postWaveFormReady) {
      <div class="marker-container" [ngClass]="{ disabled: !isAnnotationDisplayEnabled }">
        @if (enableAudioAnnotation) {
          <div class="d-block annotation-bar-container">
            <mtm-videojs-annotation-bar-list
              [projectId]="projectId"
              [disablePreview]="true"
              [sectionId]="sectionId"
              [subsectionId]="subsectionId"
              [projectParticipants]="projectParticipants"
              [typeId]="typeId"
              [item]="item"
              [annotationPlugin]="annotationPlugin"
              [isPlayerReady]="true"
              [isAudio]="true"
              [isPlaying]="isPlaying"
              [activePluginAnnotation]="activeAnnotation"
              [instanceId]="instanceId"
              [player]="wavesurfer"
              [progressBarClickedTime]="progressBarClickedTime">
            </mtm-videojs-annotation-bar-list>
          </div>
        }
      </div>
    }
  </div>
</div>
